import { Environment } from './core/interfaces/environments.interface'

export const environment: Environment = {
	production: false,
	hmr: false,
	environmentsConfigsUrl: 'https://cfg.ivlk.io/web/admin-dev.json',
}
